// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "openotp_auth-" + chunkId + ".js?v=" + "ab71fd2809a0ccd5b1f0" + "";
};